import React from 'react';
import styles from './GameModeButton.module.css';
import pantoparty from '../assets/pantoparty.svg';
import pantopartyKids from '../assets/pantopartyKids.svg';
import * as constants from '../constants';

const GameModeButton = (props) => {
    let image = null;
    let subtitle = null;
    if (!props.kids) {
        image = <img src={pantoparty} alt={constants.TEXT5} />;
        subtitle = constants.TEXT6;
    } else {
        image = <img src={pantopartyKids} alt={constants.TEXT7} />;
        subtitle = constants.TEXT8;
    }
    return <div className={styles.gameModeButton}
        onClick={() => {
            props.chooseGameMode(props.kids);
            props.changeContainer('teamCreation');
        }}>
        <div>{image}</div>
        <div className={styles.subtitle}>{subtitle}</div>
    </div>;
}

export default GameModeButton;